import { create } from "zustand";
import level2Image from "../static/Level2.png";
import { Canvas } from "models/Canvas";

type CanvasState = {
  canvasObj: Canvas | null;
  isBuilding: boolean;
  showBuild: boolean;
  towerType: string;
  initializeCanvas: (
    canvas: HTMLCanvasElement,
    context: CanvasRenderingContext2D
  ) => void;
  resetGame: () => void;
  resumePauseGame: () => void;
  startTowerBuild: () => void;
  stopTowerBuild: () => void;
  showHideTowerBuild: () => void;
  setTowerType: (type: string) => void;
};

export const useCanvasStore = create<CanvasState>((set, get) => ({
  canvasObj: null,
  isBuilding: false,
  showBuild: false,
  towerType: "archer",

  initializeCanvas: (canvas, context) => {
    const { canvasObj } = get();
    if (canvasObj) {
      return;
    }
    const image = new Image();
    image.src = level2Image;

    const newCanvasObj = new Canvas(
      canvas,
      context ?? new CanvasRenderingContext2D()
    );
    newCanvasObj.drawBackground(image, 0, 0);

    set({ canvasObj: newCanvasObj });
  },

  resetGame: () => {
    const { canvasObj } = get();
    canvasObj?.restartGame();
    set({ canvasObj: null });
  },

  resumePauseGame: () => {
    const { canvasObj } = get();
    if (canvasObj) {
      const updatedCanvasObj = canvasObj;
      updatedCanvasObj.paused = !updatedCanvasObj.paused;
      set({ canvasObj: updatedCanvasObj });
      if (!updatedCanvasObj.paused) {
        set({ isBuilding: false });
      }
    }
  },

  startTowerBuild: () => {
    set({ isBuilding: true });
  },

  stopTowerBuild: () => {
    set({ isBuilding: false });
  },

  showHideTowerBuild: () => {
    const { showBuild } = get();
    set({ showBuild: !showBuild });
  },

  setTowerType: (type: string) => {
    set({ towerType: type });
  },
}));
